<template>
  <f7-page no-toolbar no-navbar no-swipeback login-screen>
    <f7-login-screen-title>tipomoika.ru</f7-login-screen-title>
    <f7-list form>
      <f7-list-input label="Телефон" type="tel" placeholder="+7 912 987-65-32" name="phone" :value="$root.user.phone"
        @input="$root.user.phone = $event.target.value" error-message="Укажите номер телефона"
        @focus="errorUserPhone = false" :error-message-force="errorUserPhone"></f7-list-input>
      <f7-list-input v-show="isSmsSend" label="SMS-код" type="number" placeholder="1234" name="code" :value="code"
        @input="code = $event.target.value" error-message="Укажите SMS-код" @focus="errorCode = false"
        :error-message-force="errorCode"></f7-list-input>
    </f7-list>

    <f7-block>
      <f7-row tag="p">
        <f7-button round class="col" @click="checkForm" raised fill>{{ btnText }}</f7-button>
        <f7-button round class="col" href="/" raised>Отмена</f7-button>
      </f7-row>
    </f7-block>
    <f7-list>
      <f7-block-footer>Для того чтобы продолжить запись необходимо подтвердить номер телефона.</f7-block-footer>
    </f7-list>
  </f7-page>
</template>

<script>
export default {
  data() {
    return {
      code: "",
      btnText: this.checkSmsSend() ? "Далее" : "Получить код",
      errorUserPhone: false,
      errorCode: false,
      loginScreenOpened: false,
      isSmsSend: this.checkSmsSend()
    };
  },
  watch: {
    "code": {
      handler: "checkSmsCode"
    },
  },
  methods: {
    checkForm() {
      var errors = [];

      if (!this.validPhone(this.$root.user.phone)) {
        this.errorUserPhone = true;
        errors.push("errorUserPhone");
        return false;
      } else {
        this.writeStorage(this.$root.user.phone);
      }
      if (this.code == "") {
        this.errorCode = true;
        errors.push("errorUserPhone");
        this.api(
          {
            data: {
              type: "accounts",
              id: "1",
              attributes: {
                phone: parseInt(
                  this.$root.user.phone.toString().replace(/\D+/g, "")
                )
              }
            }
          },
          "POST",
          "accounts",
          []
        );
        return false;
      }
      if (!errors.length) {
        //Регистрация
        this.api(
          {
            data: {
              type: "tokens",
              id: "1",
              attributes: {
                phone: parseInt(
                  this.$root.user.phone.toString().replace(/\D+/g, "")
                ),
                code: this.code
              }
            }
          },
          "POST",
          "tokens",
          ["tokens"]
        );
      }
    },
    api(dataform, method, url = "tokens", doit = []) {
      this.$f7ready(f7 => {
        let that = this;
        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/" + url,
          method: method,
          dataType: "json",
          data: dataform == "" ? "" : JSON.stringify(dataform),
          success: function (data, status) {
            if (data.data != null) {
              that.isSmsSend = true;
              var now = new Date();
              localStorage.setItem("isSmsSend", now);
              that.btnText = "Далее";

              if (doit.indexOf("tokens") != -1) {
                localStorage.setItem("token", data.data.id);
                localStorage.setItem("user", JSON.stringify(that.$root.user));
                that.$root.user.name = data.included.attributes.username;
                that.$root.user.email = data.included.attributes.email;
                if (data.included.attributes.username !== '') {
                  console.log("На прайс.");
                  f7.views.main.router.navigate("/price/");
                } else {
                  f7.views.main.router.navigate("/start/");
                }
              }
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                // f7.dialog.alert(error.detail, "Ошибка " + error.status);
                f7.dialog.alert(
                  error.detail,
                  "Ошибка " + error.status,
                  function () {
                    if (error.status == 403) {
                      localStorage.clear();
                      f7.views.main.router.navigate("/registration/");
                    }
                  }
                );
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
            return false;
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          } //set tokenString before send
        });
      });
    },
    // api(post) {
    //   this.$f7ready(f7 => {
    //     let that = this;
    //     f7.request.post(
    //       "https://ms.bctip.ru/admin/api/typomojka/v1/" + post.data.type,
    //       JSON.stringify(post),
    //       function(data) {
    //         // console.log("data: ");
    //         // console.log(data);
    //         if (data.errors == null) {
    //           that.isSmsSend = true;
    //           var now = new Date();
    //           localStorage.setItem("isSmsSend", now);
    //           that.btnText = "Далее";
    //           if (post.data.type == "tokens") {
    //             localStorage.setItem("token", data.data.id);
    //             that.$root.user.name = data.included.attributes.username;
    //             that.$root.user.email = data.included.attributes.email;
    //             localStorage.setItem("user", JSON.stringify(that.$root.user));
    //             f7.views.main.router.navigate("/start/");
    //           }
    //         } else {
    //           data.errors.forEach(function(error) {
    //             f7.dialog.alert(error.detail, "Ошибка " + error.status);
    //           });
    //         }
    //       },
    //       "json"
    //     );
    //   });
    // },
    validPhone(phone) {
      var re = /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/;
      return re.test(phone);
    },
    checkSmsSend() {
      var date = new Date(localStorage.getItem("isSmsSend"));
      var now = new Date();
      var delta = (now.getTime() - date.getTime()) / (1000 * 60);
      return delta < 10;
    },
    checkSmsCode() {
      if (this.code.length == 4) {
        this.checkForm();
      }
    },
    writeStorage(phone) {
      let result = String(phone).match(
        /^(\+7|7|8)?[\s\-]?(\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2})$/
      );
      //console.log(result);
      this.$root.user.phone = result[2].toString();
      localStorage.setItem(
        "user",
        JSON.stringify({
          phone: parseInt(result[2].toString().replace(/\D+/g, "")),
          name: "",
          email: ""
        })
      );
    }
  },
  mounted: function () {
    if (localStorage.getItem("token") !== null) {
      this.$f7.views.main.router.navigate("/start/");
    }
  },
};
</script>


